// src/app/services/plaid.service.ts

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

// Interface for /api/create_link_token response
interface CreateLinkTokenResponse {
  link_token: string;
}

@Injectable({
  providedIn: 'root'
})
export class PlaidService {
  // Base API URL

  private baseApiUrl = environment.apiUrl.replace('/api', ''); // or directly use environment.apiUrl as needed


  constructor(private http: HttpClient) {}

  createLinkToken(applicationGuid: string): Observable<CreateLinkTokenResponse> {
    // Calls the server’s /api/create_link_token — GUID + draft cookie so the
    // backend binds the link token to the same application as the draft.
    const url = `${this.baseApiUrl}/api/create_link_token`;
    return this.http.post<CreateLinkTokenResponse>(
      url,
      { applicationGuid },
      { withCredentials: true }
    );
  }

  exchangePublicToken(public_token: string, applicationGuid: string): Observable<any> {
    // Encode the data as application/x-www-form-urlencoded
    const body = new HttpParams()
      .set('public_token', public_token)
      .set('applicationGuid', applicationGuid);

    // Set the Content-Type header
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = `${this.baseApiUrl}/api/exchange_public_token`;
    return this.http.post(url, body.toString(), { headers, withCredentials: true });
  }
}
